import moment from 'moment-timezone';

export const KOSOVO_COUNTRY_CODE = 'XK';
export const TIMEZONES = {
    KOSOVO: 'Europe/Belgrade',
    VILNIUS: 'Europe/Vilnius',
};

export const getGmtOffset = (country) => {
    if (country !== KOSOVO_COUNTRY_CODE) {
        return '';
    }
    const now = moment().tz(TIMEZONES.KOSOVO);
    const offsetMinutes = now.utcOffset();
    const offsetHours = offsetMinutes / 60;
    const sign = offsetHours >= 0 ? '+' : '-';
    return ` (GMT${sign}${Math.abs(offsetHours)})`;
};

export const getTimezoneForCountry = (country) => {
    return country === KOSOVO_COUNTRY_CODE ? TIMEZONES.KOSOVO : moment.tz.guess();
};

export const createMoment = (timestamp, country) => {
    // For Kosovo, we need to add 1 hour to the timestamp, server returns it in Vilnius timezone
    const adjustedTimestamp = country === KOSOVO_COUNTRY_CODE ? timestamp + 3600 : timestamp;
    return moment(adjustedTimestamp * 1000);
};
